import IconButton from '@anm/components/buttons/IconButton';
import Image from '@anm/components/image/Image';
import getFromCdn from '@anm/helpers/getFromCdn';
import { flexCenter, stretchBlock } from '@anm/styles/helpers';
import styled from 'styled-components';

export const Wrapper = styled.div`
  cursor: pointer;
  height: 100%;
`;

export const PreviewImage = styled(Image)`
  display: block;
  width: 160px;
  max-height: 95px;
  object-fit: cover;
  border-radius: 5px;
  border: 1px solid rgba(1, 83, 130, 0.2);
`;

export const UploadImageButton = styled(IconButton)`
  width: 160px;
  height: 90px;
  font-weight: 700;
  color: #292a2b;
  font-size: 16px;
  background: #f5f7fa;
  pointer-events: none;
  border-radius: 5px;
  border: 1px solid rgba(1, 83, 130, 0.2);
`;

export const Label = styled.label`
  position: relative;
  max-width: fit-content;
`;

export const HoverOverlay = styled.div<{ isPending: boolean; previewSrc: boolean }>`
  ${flexCenter};
  ${stretchBlock};
  cursor: pointer;
  font-weight: bold;
  font-size: 16px;
  line-height: 19px;
  padding: ${({ isPending }) => (isPending ? '14px 14px 0 0' : '0 0 0 20px')};
  background: rgba(244, 246, 247, 0.9)
    ${({ isPending }) => !isPending && `url(${getFromCdn('images/icons/ic_replace.svg')}) 26px center no-repeat`};
  opacity: ${({ isPending, previewSrc }) => !isPending && previewSrc && 0};
  &:hover {
    opacity: 1;
  }
`;
